import { useSelector } from "react-redux";
import PresortDemo from "../components/table/DataTable";
import { useEffect, useState } from "react";

import { Sidebar } from "primereact/sidebar";
import { Button } from "primereact/button";
import { InputText } from "primereact/inputtext";
import TextEditor from "../components/UI/editor/TextEditor";
import { userColumn } from "../metadata/user";
import { TabView, TabPanel } from 'primereact/tabview';
import "./page.css"
import { orderColumn } from "../metadata/order";
import { SpeedDial } from "primereact/speeddial";
import MyButton from "../components/UI/Button";
import Editor from "../components/UI/editor";
import { customerColumns } from "../metadata/cusromers";
import { useCreateOrUpdateCustomerMutation, useGetCustomersQuery } from "../store/api/customerApi";
import { primeUserColumns } from "../metadata/primeUser";
import { useActionsHook } from "../hooks/useActionsHook";
import { useNavigate } from "react-router-dom";
import { t } from "i18next";



function Customer() {
	const { data, error, isLoading } = useGetCustomersQuery();
	const navigate = useNavigate();
	const [createUpDel] = useCreateOrUpdateCustomerMutation();

	const delFunc = (row, field) => {
		createUpDel({
			id: row?.["guid"],

		})
	}
	const items = [
		{
			label: 'Add',
			icon: 'pi pi-pencil',
			command: () => {
				// toast.current.show({ severity: 'info', summary: 'Add', detail: 'Data Added' });
			}
		}
	];
	const actions = useActionsHook([
		{
			onClick: delFunc,
			icon: "pi pi-trash"
		}, {
			onClick: (e, row, field) => {
				navigate("/user-detail", {
					state: {
						clientCode: row?.['guid'],
						user_type: row?.["user_type"]
					}
				})
			},
			icon: "pi pi-pencil"
		}
	])

	const [formData, setFormData] = useState({

	});

	const [visibleLeft, setVisibleLeft] = useState({
		visible: false,
		data: null
	});

	function toggleSidebar(bool, data) {
		// setFormData(data)
		// setVisibleLeft(state => {
		// 	return {
		// 		visible: bool,
		// 		data: data
		// 	}
		// })
	}

	const onBlur = (e, attr, value) => {
		setFormData(state => {
			return {
				...state,
				[attr]: value
			}
		});
	}

	return (<>
		<p
			style={{
				paddingLeft: 12,
				fontSize: 18,
				fontWeight: 600,
			}}
		>
			{t("client")}
		</p>
		<PresortDemo
			isLoading={isLoading}
			data={data?.data ?? []}
			column={primeUserColumns.filter(i => !i.hidden) ?? Object.keys(data.data[0])}
			toggleSidebar={toggleSidebar}
			actions={actions} />
		<SpeedDial
			model={items}
			radius={120}
			type="quarter-circle"
			onClick={() => {
				toggleSidebar(true, {});
			}}
			direction="up-left"
			style={{ right: 15, bottom: 15 }} />
		<Sidebar visible={visibleLeft.visible} position="right" onHide={() => { toggleSidebar(false) }} style={{ width: "50vw" }}>
			<div className="user-sidebar">
				<div className="user-sidebar-edit">
					{
						primeUserColumns.filter((i) => i.editor).map(el => {
							return (
								<div>
									<Editor {...el} onBlur={onBlur} data={formData} />
								</div>
							)
						})
					}
					<div></div>
					<MyButton label={t("save")} onClick={() => {
						console.log(formData);

					}} />
				</div>
			</div>
		</Sidebar>
	</>);
}

export default Customer;